<template>
  <div class="homeInspectBusiness HomeContainer">
    <div v-if="carouselList[0]" class="carousel">
      <el-carousel
        :autoplay="true"
        :style="{ background: carouselList[0].background }"
      >
        <el-carousel-item v-for="item of carouselList" :key="item.url">
          <el-image
            :src="item.url"
            fit="cover"
            @click="clickCarousel(item)"
          ></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="orderContainer">
      <div class="filterItem">
        <div class="label">{{l("地区筛选")}}：</div>
        <el-cascader
          ref="cascader"
          style="width: 220px"
          size="small"
          v-model="SearchData.address"
          :options="$store.state.basicInfo.areaList"
          :props="{
            expandTrigger: 'hover',
            label: 'name',
            value: 'name',
            children: 'child',
            emitPath: true,
            checkStrictly: true,
          }"
          :placeholder="l('请选择地区')"
          filterable
          clearable
          @change="GetTableList(true)"
        >
          <template slot-scope="{ node, data }">
            <div @click="cascaderClick(data)">
              <span>{{ data.name }}</span>
              <span v-if="false && !node.isLeaf">
                ({{ data.child.length }})
              </span>
            </div>
          </template>
        </el-cascader>
      </div>
    </div>

    <div class="tableContainer">
      <template v-if="TableList.length">
        <div class="companyContainer">
          <div v-for="item of TableList" :key="item.id" class="companyItem">
            <div class="logoContainer">
              <el-image :src="item.logo" fit="contain" class="logo"></el-image>
            </div>
            <div class="textContainer">
              <div class="name_address">
                <div class="name one_lines">
                  {{ item.name }}
                </div>
                <div class="address">
                  <i class="el-icon-location-outline"></i>
                  {{ item.address }}
                </div>
              </div>
              <div class="description">{{ item.description }}</div>
            </div>
            <div class="buttonContainer">
              <div class="button" @click="goPublish(item)">{{l("预约质检")}}</div>
            </div>
          </div>
        </div>
      </template>

      <el-empty v-else :description="l('抱歉，暂时没有收录该类商家。')"> </el-empty>
    </div>

    <el-pagination
      style="justify-content: center; margin: 35px 0"
      background
      @current-change="HandleCurrentChange"
      :current-page="CurrentPage"
      :page-size="PageSize"
      layout="total, prev, pager, next, jumper"
      :total="TotalCount"
    ></el-pagination>
  </div>
</template>

<script>
import tableMixin from "@/assets/js/tableMixin";

export default {
  name: "HomeInspectBusiness",
  mixins: [tableMixin],
  data() {
    return {
      SearchData: {
        address: "",
      },
      PageSize: 8,
      carouselList: [],
    };
  },
  created() {
    this.getCarousel();
  },
  watch: {},
  methods: {
    GetTableList(resetPage) {
      if (resetPage == true) this.CurrentPage = 1;
      this.axios
        .get("/api/inspect_business/", {
          params: {
            ...this.SearchData,
            ordering: this.Sorting,
            size: this.PageSize,
            page: this.CurrentPage,
          },
        })
        .then((data) => {
          this.TotalCount = data.count;
          this.TableList = data.results;
        });
    },
    getCarousel() {
      this.axios
        .get("/api/banner/", {
          params: {
            position: "inspect_business",
            show_pc: true,
            is_show: true,
          },
        })
        .then((data) => {
          this.carouselList = data;
        });
    },
    clickCarousel(item) {
      if (item.path_pc) {
        if (item.path_pc.indexOf("http") == 0) {
          window.open(item.path_pc);
        } else {
          this.$router.push({ path: item.path_pc });
        }
      }
    },
    goPublish(item) {
      // this.$store.dispatch("updateSession").then(() => {
      //   if (this.$store.state.session.tenant) {
          this.axios
            .post(`/api/user_accusation/`, {
              record_sign: item.id,
              module: "accusation",
              comment: this.l("申请质检委托") + "：" + item.name,
            })
            .then(() => {
              this.$alert(
                `${this.l("请等待平台客服与您联系。您也可以致电专属业务员进行沟通")}`,
                this.l("质检申请已提交")
              );
            });
      //   } else {
      //     this.$message({
      //       message: this.l("认证后解锁该功能"),
      //       type: "error",
      //       duration: 5000,
      //       showClose: true,
      //     });
      //     this.$router.push("/backend/dashboard");
      //   }
      // });
    },
    cascaderClick(nodeData) {
      this.addrCode = nodeData.name;
      this.$refs.cascader.checkedValue = nodeData.name;
      this.$refs.cascader.computePresentText();
      this.$refs.cascader.toggleDropDownVisible(false);
    },
  },
};
</script>


<style scoped lang="scss">
.homeInspectBusiness {
  .carousel {
    width: 100%;
    height: 190px;
    position: relative;
    .el-carousel {
      width: 100%;
      height: 100%;
      /deep/.el-carousel__container {
        height: 100%;
        .el-carousel__item {
          height: 100%;
        }

        .el-carousel__item .el-image {
          height: 100%;
          width: 100%;
        }
      }
    }
  }

  .orderContainer {
    margin-top: 12px;
    display: flex;
    line-height: 45px;
    text-align: center;
    border: 1px solid $borderPlainColor;
    box-sizing: border-box;
    background: #fff;

    .filterItem {
      padding: 0 20px;
      display: flex;
      align-items: center;
      // border-right: 1px solid $borderPlainColor;
      .label {
        margin-right: 10px;
      }
    }
  }

  .tableContainer {
    background: #fff;
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    margin-top: 15px;

    .companyContainer {
      .companyItem {
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        padding-top: 22px;
        padding-bottom: 22px;
        border-bottom: 1px solid $borderPlainColor;
        position: relative;
        .logoContainer {
          width: 167px;
          height: 124px;
          border: 1px solid $borderColor;
          .logo {
            width: 123px;
            height: 66px;
            margin-left: 22px;
            margin-top: 28px;
          }
        }
        .textContainer {
          width: 720px;
          .name_address {
            margin-top: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .name {
              font-size: 18px;
              flex-shrink: 0;
              width: 0;
              flex-grow: 1;
              margin-right: 20px;
            }
            .address {
              font-size: 12px;
              color: #666;
              flex-shrink: 0;
            }
          }
          .description {
            color: #999;
            margin-top: 12px;
            line-height: 24px;
            max-height: 72px;
            overflow: hidden;
          }
        }
        .buttonContainer {
          width: 230px;
          border-left: 1px solid $borderColor;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .button {
            width: 130px;
            height: 38px;
            margin: 0 auto;
            border: 1px solid $warningColor;
            color: $warningColor;
            text-align: center;
            line-height: 38px;
            cursor: pointer;
            &:hover {
              color: #fff;
              background: $warningColor;
            }
          }
        }
      }
    }
  }
}
</style>

